export const getBase64OfImage = (url: string) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.setAttribute('crossOrigin', 'anonymous');
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx?.drawImage(img, 0, 0);
      const dataURL = canvas.toDataURL('image/png');
      resolve(dataURL);
    };
    img.src = url;
  });
};

export const getImageRatio = (url: string): Promise<number> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      resolve(img.width / img.height);
    };
    img.src = url;
  });
};

export const printIframe = (frameElement: HTMLIFrameElement) => {
  try {
    setTimeout(() => {
      const frameWindow = frameElement.contentWindow;
      frameWindow?.focus();
      try {
        if (!frameWindow?.document.execCommand('print', false)) {
          frameWindow?.print();
        }
      } catch (e) {
        frameWindow?.print();
      }
      frameWindow?.close();
    }, 16);
  } catch (err) {
    console.log('err', err);
  }
};

/**
 * @param url String url of the image
 */
export const printImage = async (url: string) => {
  const iframe = document.createElement('iframe');
  document.body.appendChild(iframe);
  const base64Image = await getBase64OfImage(url);
  const ratio = await getImageRatio(url);
  iframe.append(`<img src="${base64Image}" />`);
  const img = iframe.querySelector('img');
  if (ratio > 1) {
    //  表示是横图, 横图的话，需要逆时针旋转90度
    img?.setAttribute('style', 'transform: rotate(90deg)');
  } else {
    //  表示是竖图, 竖图的话，不需要旋转
  }

  printIframe(iframe);
};


export function printImageWithOrientation(imgElement: HTMLImageElement) {
  if (!imgElement) {
    console.error('Image element not found.');
    return;
  }

  const width = imgElement.naturalWidth;
  const height = imgElement.naturalHeight;
  const isLandscape = width > height;

  const iframe = document.createElement('iframe');
  iframe.style.position = 'absolute';
  iframe.style.top = '0';
  iframe.style.left = '0';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = 'none';

  document.body.appendChild(iframe);

  const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
  if (!iframeDoc) {
    console.error('Failed to access iframe document.');
    document.body.removeChild(iframe);
    return;
  }

  iframeDoc.open();
  const html = `
    <!DOCTYPE html>
    <html>
      <head>
        <style>
          @page {
            margin: 0;
          }
          body {
            margin: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100vh;
          }
          
          img {
            position: absolute;
            object-fit: cover;                      
          }
          
          .img-wide {
            object-position: bottom right;
            transform: rotate(-90deg);
            width: 100vh;
            height: 100vw;
          }
          
          .img-tall {
            object-position: top right;
            width: 100vw;
            height: 100vh;
          }
        </style>
      </head>
      <body>
        <img src="${imgElement.src}" alt="Printable Image" class="img ${isLandscape ? 'img-wide' : 'img-tall'}" />
      </body>
    </html>
  `;
  iframeDoc.write(html);
  iframeDoc.close();

  iframe.onload = () => {
    iframe.contentWindow?.print();
    document.body.removeChild(iframe);
  };
}
